import {DataFormField} from "types/models/input-field-type";
import {FIELD_TYPE} from "types/enums";
import Icon from "@ant-design/icons";
import Icons from "assets/icons";
import React from "react";

const {RADIO, INPUT, RADIO_BUTTON} = FIELD_TYPE;

const css = {xs: 24, sm: 24, md: 12, lg: 12, xl: 12};
const wrapperCol = {xs: 18, md: 18, lg: 18};
const labelCol = {xs: 6, md: 6, lg: 6};

export const FieldsAnterior1: any[] = [
  {
    name: ["rightJsonValue", "ANTERIOR_CHAMBER", "Độ sâu"],
    type: RADIO_BUTTON,
    css: css,
    labelCol: {xs: 6, md: 6, lg: 6},
    wrapperCol: {xs: 18, md: 18, lg: 18},
    label: "Độ sâu",
    radioButtons: [
      {
        label: "Bình thường",
        value: "Bình thường",
        span: 8,
      },
      {
        label: "Nông",
        value: "Nông",
        span: 8,
      },
      {
        label: "Sâu",
        value: "Sâu",
        span: 8,
      },
    ],
    value: "Bình thường",
  },
  {
    label: "Tế bào:",
    type: RADIO_BUTTON,
    radioButtons: [
      {
        label: "Có",
        value: true,
        span: 8,
      },
      {
        label: "Không",
        value: false,
        span: 8,
      },
    ],
    value: false,
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    name: ["rightJsonValue", "ANTERIOR_CHAMBER", "Tế bào"],
  },
  {
    label: "Flare:",
    type: RADIO_BUTTON,
    radioButtons: [
      {
        label: "Có",
        value: true,
        span: 8,
      },
      {
        label: "Không",
        value: false,
        span: 8,
      },
    ],
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    name: ["rightJsonValue", "ANTERIOR_CHAMBER", "Flare"],
    value: false,
  },
  {
    label: "Máu tiền phòng",
    type: RADIO_BUTTON,
    radioButtons: [
      {
        label: "Có",
        value: true,
        span: 8,
      },
      {
        label: "Không",
        value: false,
        span: 8,
      },
    ],
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    name: ["rightJsonValue", "ANTERIOR_CHAMBER", "Máu tiền phòng"],
    value: false,
  },
  {
    label: "Mủ tiền phòng",
    type: RADIO_BUTTON,
    radioButtons: [
      {
        label: "Có",
        value: true,
        span: 8,
      },
      {
        label: "Không",
        value: false,
        span: 8,
      },
    ],
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    name: ["rightJsonValue", "ANTERIOR_CHAMBER", "Mủ tiền phòng"],
    value: false,
  },
  {
    label: "Dị vật",
    type: RADIO_BUTTON,
    radioButtons: [
      {
        label: "Có",
        value: true,
        span: 8,
      },
      {
        label: "Không",
        value: false,
        span: 8,
      },
    ],
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    name: ["rightJsonValue", "ANTERIOR_CHAMBER", "Dị vật"],
    value: false,
  },
  {
    label: "Ghi chú",
    type: INPUT,
    name: ["rightJsonValue", "ANTERIOR_CHAMBER", "Ghi chú"],
    css: {xs: 24, md: 24, lg: 24},
    labelCol: {xs: 4, md: 4, lg: 4},
    wrapperCol: {xs: 20, md: 20, lg: 20},
  },
  {
    label: "show",
    type: INPUT,
    name: ["rightJsonValue", "ANTERIOR_CHAMBER", "show"],
    hide: true,
  },
];

export const FieldsAnterior2: any[] = [
  {
    name: ["leftJsonValue", "ANTERIOR_CHAMBER", "Độ sâu"],
    type: RADIO_BUTTON,
    css: css,
    labelCol: {xs: 6, md: 6, lg: 6},
    wrapperCol: {xs: 18, md: 18, lg: 18},
    label: "Độ sâu",
    radioButtons: [
      {
        label: "Bình thường",
        value: "Bình thường",
        span: 8,
      },
      {
        label: "Nông",
        value: "Nông",
        span: 8,
      },
      {
        label: "Sâu",
        value: "Sâu",
        span: 8,
      },
    ],
    value: "Bình thường",
  },
  {
    label: "Tế bào:",
    type: RADIO_BUTTON,
    radioButtons: [
      {
        label: "Có",
        value: true,
        span: 8,
      },
      {
        label: "Không",
        value: false,
        span: 8,
      },
    ],
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    name: ["leftJsonValue", "ANTERIOR_CHAMBER", "Tế bào"],
    value: false,
  },
  {
    label: "Flare:",
    type: RADIO_BUTTON,
    radioButtons: [
      {
        label: "Có",
        value: true,
        span: 8,
      },
      {
        label: "Không",
        value: false,
        span: 8,
      },
    ],
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    name: ["leftJsonValue", "ANTERIOR_CHAMBER", "Flare"],
    value: false,
  },
  {
    label: "Máu tiền phòng",
    type: RADIO_BUTTON,
    radioButtons: [
      {
        label: "Có",
        value: true,
        span: 8,
      },
      {
        label: "Không",
        value: false,
        span: 8,
      },
    ],
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    name: ["leftJsonValue", "ANTERIOR_CHAMBER", "Máu tiền phòng"],
    value: false,
  },
  {
    label: "Mủ tiền phòng",
    type: RADIO_BUTTON,
    radioButtons: [
      {
        label: "Có",
        value: true,
        span: 8,
      },
      {
        label: "Không",
        value: false,
        span: 8,
      },
    ],
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    name: ["leftJsonValue", "ANTERIOR_CHAMBER", "Mủ tiền phòng"],
    value: false,
  },
  {
    label: "Dị vật",
    type: RADIO_BUTTON,
    radioButtons: [
      {
        label: "Có",
        value: true,
        span: 8,
      },
      {
        label: "Không",
        value: false,
        span: 8,
      },
    ],
    css: css,
    labelCol: labelCol,
    wrapperCol: wrapperCol,
    name: ["leftJsonValue", "ANTERIOR_CHAMBER", "Dị vật"],
    value: false,
  },
  {
    label: "Ghi chú",
    type: INPUT,
    name: ["leftJsonValue", "ANTERIOR_CHAMBER", "Ghi chú"],
    css: {xs: 24, md: 24, lg: 24},
    labelCol: {xs: 4, md: 4, lg: 4},
    wrapperCol: {xs: 20, md: 20, lg: 20},

    // suffix: (
    //   <Icon
    //     rev={0}
    //     style={{fontSize: "24px"}}
    //     component={Icons.file as React.ForwardRefExoticComponent<any>}
    //   />
    // ),
  },
  {
    label: "show",
    type: INPUT,
    name: ["leftJsonValue", "ANTERIOR_CHAMBER", "show"],
    hide: true,
  },
];
